<template>
  <div>
    <html>

    <body>

      <head>
        <meta charset="utf-8" />
        <title>{{ info.title ? info.title : defaultConfig.title }}</title>
        <meta name="keywords" :content="info.keyword ? info.keyword : defaultConfig.meta.keywords" />
        <meta name="description" :content="info.summary ? info.summary : defaultConfig.meta.description
          " />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </head>

      <header :class="isVisible
          ? 'header-navigation slideDown'
          : 'header-navigation slideUp'
        " id="header" :style="{ height: '60px' }">
        <nav>
          <div class="logo">
            <el-image v-if="info.logoPhoto" style="
                  width: 35px;
                  height: 35px;
                  vertical-align: middle;
                  margin-top: -6px;
                " :src="info.logoPhoto"></el-image>
            <router-link to="/">
              <a href="javascript:void(0);" v-if="info.name">{{
                info.name
              }}</a>
            </router-link>
          </div>

          <h2 id="mnavh" @click="openHead" :class="showHead ? 'open' : ''">
            <span class="navicon"></span>
          </h2>

          <ul id="starlist" :style="showHead ? 'display: block' : ''">
            <li v-for="webNavbar in webNavbarList" :key="webNavbar.uid" @click="clickWebNavbar(webNavbar)">
              <!--判断是否有下拉菜单-->
              <span v-if="
                webNavbar.childWebNavbar &&
                webNavbar.childWebNavbar.length > 0
              ">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link" :style="{
                    color:
                      saveTitle == webNavbar.url ||
                        saveTitle == webNavbar.name
                        ? '#007fff'
                        : webNavbar.color,
                  }">
                    {{ webNavbar.name
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="childWebNavbar in webNavbar.childWebNavbar" :key="childWebNavbar.uid">
                      <router-link :to="childWebNavbar.url" v-if="childWebNavbar.isJumpExternalUrl == 0">
                        <span @click="openHead" :style="{ color: childWebNavbar.color }">{{ childWebNavbar.name
                          }}</span>
                      </router-link>
                      <a v-if="childWebNavbar.isJumpExternalUrl == 1" :href="childWebNavbar.url"
                        :style="{ color: childWebNavbar.color }" target="_blank">{{ childWebNavbar.name }}</a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>

              <!--没有有下拉菜单-->
              <span v-else>
                <router-link :to="webNavbar.url" v-if="webNavbar.isJumpExternalUrl == 0">
                  <span @click="openHead" :style="{
                    color:
                      saveTitle == webNavbar.url ||
                        saveTitle == webNavbar.name
                        ? '#007fff'
                        : webNavbar.color,
                  }" :class="[
                        saveTitle == webNavbar.url ||
                          saveTitle == webNavbar.name
                          ? 'title'
                          : '',
                      ]">{{ webNavbar.name }}</span>
                </router-link>
                <a v-if="webNavbar.isJumpExternalUrl == 1" :href="webNavbar.url" target="_blank" :class="[
                  saveTitle == webNavbar.url || saveTitle == webNavbar.name
                    ? 'title'
                    : '',
                ]">{{ webNavbar.name }}</a>
              </span>
            </li>
          </ul>

          <div class="modern-search-container" v-if="componentShowMap.showUserSearch" @click.stop="() => { }">
            <div class="search-wrapper">
              <div class="search-input-group">
                <i class="el-icon-search search-icon"></i>
                <input
                  ref="searchInput"
                  class="search-input"
                  placeholder="搜索技术文章、问题、资源..."
                  type="text"
                  v-model="keyword"
                  @keyup.enter="search"
                  @focus="showHotSearch"
                  @blur="handleInputBlur"
                  autocomplete="off"
                />
                <div class="search-button" @click="search" v-if="keyword.trim()">
                  <i class="el-icon-search"></i>
                </div>
              </div>
            </div>

            <!-- 热搜下拉框 -->
            <div class="search-suggestions" v-if="dialogHotSearchVisible" @mouseenter="onCardEnterTd" @mouseleave="onLeaveTd">
              <div class="suggestions-list">
                <div
                  class="suggestion-item"
                  v-for="(item, index) in hotSearchList"
                  :key="item.uid"
                  @click="selectHotSearch(item.content)"
                >
                  <i class="el-icon-search suggestion-icon"></i>
                  <span class="suggestion-text">{{ item.content }}</span>
                  <span class="suggestion-label" v-if="index < 3">热</span>
                </div>
              </div>
            </div>
          </div>

          <el-dropdown @command="handleCommand" class="create" placement="bottom">
            <span class="el-dropdown-link">
              <el-button v-if="componentShowMap.showCreateButton" type="primary" size="small" icon="el-icon-edit"
                :disabled="!authCode.ADD_BLOG &&
                  !authCode.ADD_EXPERIENCE &&
                  !authCode.UPLOAD_BLOG &&
                  !authCode.UPLOAD_EXPERIENCE &&
                  !authCode.ADD_QUESTION &&
                  !authCode.ADD_MOMENT &&
                  !authCode.ADD_PROBLEM
                  " class="createBlog">创作</el-button>
            </span>

            <el-dropdown-menu slot="dropdown" class="create-dropdown-menu">
              <div class="create-grid-layout">
                <div class="create-grid-container">
                  <!-- 第一行 -->
                  <div class="create-item" @click="goToCreatePage('/createdCenter/createTask')">
                    <div class="create-icon">
                      <i class="el-icon-trophy"></i>
                    </div>
                    <span class="create-text">发布任务</span>
                  </div>
                  <div class="create-item" @click="goToCreatePage('/createdCenter/createBlog')">
                    <div class="create-icon">
                      <i class="el-icon-edit"></i>
                    </div>
                    <span class="create-text">发布经验</span>
                  </div>

                  <div class="create-item" @click="goToCreatePage('/createdCenter/createTool')">
                    <div class="create-icon">
                      <i class="el-icon-setting"></i>
                    </div>
                    <span class="create-text">发布工具</span>
                  </div>
                  <div class="create-item" @click="goToCreatePage('/createdCenter/createDoc')">
                    <div class="create-icon">
                      <i class="el-icon-document"></i>
                    </div>
                    <span class="create-text">发布文档</span>
                  </div>

                  <!-- 第二行 -->
                  <div class="create-item create-center-item" @click="handleCommand('goCreateCenter')">
                    <div class="create-icon">
                      <i class="el-icon-edit-outline"></i>
                    </div>
                    <span class="create-text">创作中心</span>
                  </div>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommand" class="vipIcon" v-if="componentShowMap.showVipModel" placement="bottom"
            trigger="hover" style="border-radius: 10px">
            <span class="el-dropdown-link">
              <div class="vip-entry-icon">
                <div class="crown-vip-icon">
                  <svg viewBox="0 0 60 60" width="34" height="34">
                    <!-- 皇冠 -->
                    <path d="M15 20 L20 12 L25 18 L30 8 L35 18 L40 12 L45 20 L42 25 L18 25 Z"
                          fill="url(#crownGradient)" stroke="#d4580a" stroke-width="1"/>

                    <!-- 钻石形状徽章 -->
                    <path d="M30 25 L45 30 L40 50 L20 50 L15 30 Z"
                          fill="url(#badgeGradient)" stroke="#d4580a" stroke-width="1.5"/>

                    <!-- VIP文字 -->
                    <text x="30" y="42" text-anchor="middle" fill="#ff6600"
                          font-family="Arial, sans-serif" font-size="18" font-weight="bold">V</text>

                    <!-- 高光效果 -->
                    <ellipse cx="25" cy="35" rx="3" ry="8" fill="rgba(255,255,255,0.3)"/>

                    <!-- 渐变定义 -->
                    <defs>
                      <linearGradient id="crownGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color:#ffd700;stop-opacity:1" />
                        <stop offset="100%" style="stop-color:#ff8c00;stop-opacity:1" />
                      </linearGradient>
                      <linearGradient id="badgeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color:#fff2cc;stop-opacity:1" />
                        <stop offset="30%" style="stop-color:#ffe066;stop-opacity:1" />
                        <stop offset="70%" style="stop-color:#ffb84d;stop-opacity:1" />
                        <stop offset="100%" style="stop-color:#ff8c42;stop-opacity:1" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </span>

            <el-dropdown-menu slot="dropdown" class="userDropdownMenu">
              <el-dropdown-item command="openVip" class="userDropdownMenuItem">
                <el-card :body-style="{ padding: '20px' }" style="width: 380px; cursor: default" class="vipCardStyle">
                  <el-row class="vipCardTitle" style="text-align: center; line-height: 25px">
                    <el-row type="flex" justify="space-around" style="text-align: center">
                      <el-col :span="6" style="margin-top: -6px">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50"
                          height="3" viewBox="0 0 50 3" fill="none">
                          <path d="M50 3L50 0L0 2L50 3Z" fill="url(#linear_fill_11_12)"></path>
                          <defs>
                            <linearGradient id="linear_fill_11_12" x1="-16.2236328125" y1="3" x2="50" y2="1.5"
                              gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FF8C00" stop-opacity="0.73" />
                              <stop offset="1" stop-color="#FF8C00" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </el-col>
                      <el-col :span="12">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="20.9853515625" height="18.935546875" viewBox="0 0 20.9853515625 18.935546875"
                          fill="none">
                          <path
                            d="M20.9856 0.00835529L13.4662 0L6.01373 9.13011L6.01373 1.58181L6.01373 1.44034L6.01373 0.00835529L0 0.00835529L0 1.58181L1.50495 1.58181L1.50495 18.9364L6.01373 18.9364L6.01373 18.9364L20.9856 0.00835529Z"
                            fill="#FF6600"></path>
                        </svg>
                        <span>会员尊享特权</span>
                      </el-col>
                      <el-col :span="6" style="margin-top: -6px">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50"
                          height="5" viewBox="0 0 50 3" fill="none">
                          <path d="M0 3L0 0L50 2L0 3Z" fill="url(#linear_fill_11_13)"></path>
                          <defs>
                            <linearGradient id="linear_fill_11_13" x1="66.2236328125" y1="8" x2="0" y2="4.5"
                              gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FF8C00" stop-opacity="0.73" />
                              <stop offset="1" stop-color="#FF6600" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </el-col>
                    </el-row>
                  </el-row>

                  <el-row :span="24" type="flex" justify="space-around">
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23"
                          height="18" viewBox="0 0 23 18" fill="none">
                          <path
                            d="M12.9398 4.3773L19.9842 4.3773C20.2717 4.3773 20.4163 4.09094 20.4163 3.80457L20.4163 2.0864C20.4163 1.80004 20.2717 1.51367 19.9842 1.51367L11.645 1.51367C11.2145 1.51367 11.0699 2.0864 11.3574 2.37277L12.6523 4.2333C12.6523 4.3773 12.7952 4.3773 12.9398 4.3773Z"
                            fill="#FF8C00"></path>
                          <path
                            d="M20.2735 5.52353L12.9398 5.52353C12.6523 5.52353 12.2201 5.37953 12.0772 4.9508L9.20156 1.22807C9.19367 1.21937 9.18569 1.21078 9.17759 1.2023C9.16947 1.19382 9.16126 1.18545 9.15293 1.17719C9.14458 1.16893 9.13614 1.16078 9.12757 1.15275C9.11902 1.14471 9.11036 1.1368 9.1016 1.129C9.09283 1.1212 9.08395 1.11352 9.07498 1.10595C9.066 1.09839 9.05691 1.09096 9.04773 1.08364C9.03853 1.07632 9.02926 1.06913 9.01987 1.06207C9.01052 1.055 9.00106 1.04806 8.99147 1.04125C8.9819 1.03444 8.97225 1.02776 8.96251 1.0212C8.95276 1.01465 8.94291 1.00823 8.93299 1.00195C8.92307 0.995661 8.91308 0.989508 8.90298 0.98349C8.89291 0.977474 8.88274 0.971593 8.8725 0.965849C8.86224 0.960106 8.85192 0.954501 8.84152 0.949036C8.83113 0.94357 8.82066 0.938245 8.81012 0.933062C8.79956 0.927878 8.78896 0.922837 8.77826 0.91794C8.7676 0.913041 8.75685 0.908288 8.74604 0.903681C8.73522 0.899072 8.72435 0.894609 8.71341 0.890293C8.70248 0.885977 8.6915 0.881809 8.68045 0.87779C8.66942 0.873769 8.65832 0.869898 8.64716 0.866178C8.636 0.862456 8.62481 0.858885 8.61357 0.855466C8.60233 0.852046 8.59105 0.848778 8.5797 0.845662C8.56838 0.842547 8.557 0.839585 8.54558 0.836775C8.53415 0.833966 8.5227 0.831311 8.51123 0.82881C8.49973 0.826308 8.48821 0.823962 8.47666 0.821772C8.46512 0.81958 8.45354 0.817545 8.44193 0.815667C8.43031 0.813787 8.4187 0.812065 8.40703 0.810499C8.3954 0.808933 8.38371 0.807525 8.37201 0.806273C8.36032 0.805022 8.3486 0.803927 8.33688 0.802989C8.32516 0.802053 8.31344 0.801275 8.30172 0.800655C8.28996 0.800034 8.27822 0.799572 8.26647 0.799268C8.2547 0.798964 8.24296 0.798817 8.2312 0.798829C8.21943 0.798842 8.20767 0.799013 8.1959 0.799342L2.87523 0.799342C2.1555 0.799342 1.58203 1.51443 1.58203 2.22952L1.58203 16.2613C1.58203 17.1221 2.15715 17.6947 2.87523 17.6947L20.2735 17.6947C20.9915 17.6947 21.5666 16.9781 21.5666 16.2613L21.5666 6.95533C21.5666 6.09626 20.9915 5.52353 20.2735 5.52353ZM14.2347 13.3993C14.2347 13.8281 13.9471 14.1144 13.515 14.1144L4.60059 14.1144C4.17007 14.1144 3.88087 13.8281 3.88087 13.3977C3.88087 12.969 4.16843 12.6826 4.60059 12.6826L13.6596 12.6826C13.9471 12.6826 14.2347 12.969 14.2347 13.3993ZM17.9714 13.3993C17.9714 13.8281 17.6837 14.1144 17.2533 14.1144L16.6781 14.1144C16.246 14.1144 15.9584 13.8281 15.9584 13.3977C15.9584 12.969 16.246 12.6826 16.6781 12.6826L17.2532 12.6826C17.6837 12.6826 17.973 12.969 17.973 13.3993L17.9714 13.3993Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">会员资源</div>
                    </el-col>
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23"
                          height="23" viewBox="0 0 23 23" fill="none">
                          <path
                            d="M18.0137 0.898438L7.1875 0.898438C6.11836 0.898438 5.25586 2.0125 5.25586 3.10859L17.7172 3.10859L17.7172 19.2176C18.7863 19.2176 19.9543 18.3281 19.9543 17.223L19.9543 2.89297C19.9453 1.78789 19.0828 0.898438 18.0137 0.898438ZM15.1566 4.06094L14.5187 4.06094L14.5187 9.43359L12.7848 7.36718L11.0059 9.43359L11.0059 4.06094L4.29453 4.06094C3.41406 4.06094 2.69531 4.76172 2.69531 5.6332L2.69531 20.1609C2.69531 21.0324 3.41406 21.7422 4.29453 21.7422L15.1566 21.7422C16.0371 21.7422 16.7559 21.0324 16.7559 20.1609L16.7559 5.6332C16.7469 4.76172 16.0371 4.06094 15.1566 4.06094ZM14.5187 17.798C14.5187 17.8879 14.4469 17.9598 14.357 17.9598L5.09414 17.9598C5.0043 17.9598 4.93242 17.8879 4.93242 17.798L4.93242 16.8547C4.93242 16.7648 5.0043 16.693 5.09414 16.693L14.357 16.693C14.4469 16.693 14.5187 16.7648 14.5187 16.8547L14.5187 17.798ZM14.5187 15.2644C14.5187 15.3543 14.4469 15.4262 14.357 15.4262L5.09414 15.4262C5.0043 15.4262 4.93242 15.3543 4.93242 15.2644L4.93242 14.3211C4.93242 14.2312 5.0043 14.1594 5.09414 14.1594L14.357 14.1594C14.4469 14.1594 14.5187 14.2312 14.5187 14.3211L14.5187 15.2644ZM14.5187 12.7398C14.5187 12.8297 14.4469 12.9016 14.357 12.9016L5.09414 12.9016C5.0043 12.9016 4.93242 12.8297 4.93242 12.7398L4.93242 11.7965C4.93242 11.7066 5.0043 11.6348 5.09414 11.6348L14.357 11.6348C14.4469 11.6348 14.5187 11.7066 14.5187 11.7965L14.5187 12.7398Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">会员等级保护</div>
                    </el-col>
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23"
                          height="23" viewBox="0 0 23 23" fill="none">
                          <path
                            d="M1.06263 8.8015L1.06263 12.4477L0.183706 13.4539L1.87115 14.9168L3.41339 13.4539L2.48575 12.4213L2.48575 9.4048C7.47194 11.4388 8.82191 12.0709 9.92746 12.5644C11.0333 13.058 11.8298 13.0555 12.9265 12.6466C14.0233 12.2379 18.9957 10.3526 21.5881 9.12514C23.3181 8.30594 23.4295 7.7868 21.5584 7.09168C19.1167 6.17386 15.3292 4.70413 13.1899 3.90205C11.9234 3.39501 11.254 3.11838 10.0915 3.69653C8.01597 4.54445 3.52176 6.30512 1.16361 7.26833C-0.889252 8.1548 0.490883 8.44634 1.06263 8.80147L1.06263 8.8015ZM9.68699 14.077C8.48129 13.5846 6.85553 12.7707 5.08277 12.0194L5.08277 18.0522C5.08277 18.0522 7.37554 20.4651 11.4059 20.4651C15.7464 20.4651 18.091 18.0522 18.091 18.0522L18.091 12.4213C16.7227 12.9727 15.1863 13.4472 13.3269 14.077C12.1809 14.4803 10.7267 14.6196 9.68699 14.077L9.68699 14.077Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">工程师自荐</div>
                    </el-col>
                  </el-row>

                  <el-row class="loginSummary" :span="24" type="flex" justify="space-around">
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23"
                          height="23" viewBox="0 0 23 23" fill="none">
                          <path
                            d="M17.751 8.64775L13.2791 8.64775L16.163 2.44629C16.3068 2.01279 15.8755 1.43555 15.442 1.43555L9.67408 1.43555C9.38658 1.43555 9.09684 1.5793 8.95309 1.86904L4.62487 13.4072C4.48112 13.9845 4.91237 14.4157 5.34587 14.4157L10.3951 14.4157L8.95309 20.9069L8.95309 21.0507C8.95309 21.3382 9.24059 21.6279 9.53033 21.6279C9.67408 21.6279 9.96383 21.4842 9.96383 21.3404L18.3283 9.79999C18.6158 9.22275 18.3283 8.64775 17.751 8.64775Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">任务发布/接取</div>
                    </el-col>
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21"
                          height="21" viewBox="0 0 21 21" fill="none">
                          <path
                            d="M19.6689 13.1248L18.3577 13.1248L18.3577 15.7497L15.7353 13.1248L7.86813 13.1248C7.14395 13.1248 6.55693 12.5372 6.55693 11.8123L6.55693 2.62497C6.55693 1.90009 7.14395 1.3125 7.86813 1.3125L19.6688 1.3125C20.393 1.3125 20.9801 1.90009 20.9801 2.62497L20.9801 11.8123C20.9801 12.5372 20.393 13.1248 19.6688 13.1248L19.6689 13.1248ZM9.83494 6.56238C9.47292 6.56238 9.17933 6.85623 9.17933 7.21863C9.17933 7.58102 9.4729 7.87488 9.83494 7.87488C10.197 7.87488 10.4905 7.58102 10.4905 7.21863C10.4905 6.85623 10.1969 6.56238 9.83494 6.56238ZM13.7685 6.56238C13.4065 6.56238 13.1129 6.85623 13.1129 7.21863C13.1129 7.58102 13.4065 7.87488 13.7685 7.87488C14.1306 7.87488 14.4241 7.58102 14.4241 7.21863C14.4241 6.85623 14.1305 6.56238 13.7685 6.56238ZM17.7021 6.56238C17.3401 6.56238 17.0465 6.85623 17.0465 7.21863C17.0465 7.58102 17.3401 7.87488 17.7021 7.87488C18.0641 7.87488 18.3577 7.58102 18.3577 7.21863C18.3577 6.85623 18.0641 6.56238 17.7021 6.56238ZM14.4241 14.4372L14.4241 17.0622C14.4241 17.7871 13.8371 18.3746 13.1129 18.3746L5.24575 18.3746L2.62335 20.9995L2.62335 18.3746L1.31217 18.3746C0.587991 18.3746 0.000976562 17.7871 0.000976562 17.0622L0.000976562 7.87486C0.000976562 7.14997 0.587991 6.56238 1.31217 6.56238L5.24575 6.56238L5.24575 13.1248C5.24575 13.8496 5.83277 14.4372 6.55693 14.4372L14.4241 14.4372L14.4241 14.4372Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">1V1交流</div>
                    </el-col>
                    <el-col :span="8" class="vipIconItem">
                      <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23"
                          height="23" viewBox="0 0 23 23" fill="none">
                          <path
                            d="M17.0546 17.7675C17.2616 16.997 17.5951 16.7095 17.4341 13.5125C22.9425 8.05 22.9885 0.483 22.9885 0.023L23 0.0115L22.9885 0.0115L22.9885 0L22.9771 0.0115C22.5171 0.0115 14.9501 0.0575 9.4876 5.5545C6.2906 5.3935 5.9916 5.727 5.2326 5.934C3.84111 6.325 0.391111 10.0165 0.0576107 11.3045C-0.275888 12.5925 1.09261 12.788 1.58711 12.834C2.08161 12.88 4.76111 12.581 4.99111 12.949C4.99111 12.949 5.4166 13.2365 5.4396 14.03C5.4626 14.812 5.8306 15.893 6.4056 16.5715L6.4171 16.583L6.4286 16.5945C7.1071 17.1695 8.1881 17.5375 8.9701 17.5605C9.7636 17.5835 10.0511 18.009 10.0511 18.009C10.4076 18.239 10.1201 20.9185 10.1661 21.413C10.2121 21.9075 10.4191 23.2875 11.6956 22.9425C12.9836 22.6089 16.6751 19.159 17.0546 17.7675ZM13.2596 9.74049C12.2016 8.717 12.1671 7.015 13.2021 5.957C14.2256 4.899 15.9276 4.8645 16.9856 5.8995L17.0431 5.957C18.0666 7.015 18.0436 8.717 16.9856 9.74049C15.9506 10.741 14.3061 10.741 13.2596 9.74049ZM7.0611 18.7105C6.2216 18.5955 5.6236 18.2275 5.1981 17.779C4.74961 17.342 4.39311 16.744 4.26661 15.916C4.14011 15.18 3.72611 14.835 3.25461 14.904C2.78311 14.9615 1.24211 16.652 1.13861 17.2385C1.03511 17.8365 1.90911 17.549 2.35761 17.963C2.80611 18.3655 2.30011 19.5845 1.96661 20.2285C1.79411 20.562 1.70211 20.9185 1.85161 21.114C2.04711 21.275 2.40361 21.1715 2.73711 20.999C3.39261 20.6655 4.60011 20.171 5.0026 20.6195C5.4051 21.068 5.12911 21.9305 5.7271 21.8385C6.3251 21.735 8.0041 20.194 8.0616 19.7225C8.1306 19.2625 7.7971 18.837 7.0611 18.7105Z"
                            fill="#FF8C00"></path>
                        </svg>
                      </div>
                      <div class="title">优先响应</div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <button class="vipButton" style="width: 100%; margin-top: 20px; cursor: pointer">
                      开通会员
                    </button>
                  </el-row>
                </el-card>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommand" class="notice" v-if="componentShowMap.showUserNotice"
            placement="bottom">
            <span class="el-dropdown-link">
              <i class="el-icon-bell">
                <el-badge is-dot style="margin-top: -25px" class="item" :value="userReceiveCommentCount" :hidden="userReceiveCommentCount +
                  userReceiveWatchCount +
                  userReceivePraiseCount +
                  userReceiveSystemCount +
                  userReceiveMessageCount +
                  userReceiveCollectCount === 0"></el-badge>
              </i>
            </span>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="comment">
                评论
                <el-badge is-dot :value="userReceiveCommentCount" class="item"
                  :hidden="userReceiveCommentCount == 0"></el-badge>
              </el-dropdown-item>
              <el-dropdown-item command="watch">
                关注
                <el-badge is-dot :value="userReceiveWatchCount" class="item"
                  :hidden="userReceiveWatchCount == 0"></el-badge>
              </el-dropdown-item>
              <el-dropdown-item command="praise">
                点赞
                <el-badge is-dot :value="userReceivePraiseCount" class="item"
                  :hidden="userReceivePraiseCount == 0"></el-badge>
              </el-dropdown-item>
              <el-dropdown-item command="system">
                系统通知
                <el-badge is-dot :value="userReceiveSystemCount" class="item"
                  :hidden="userReceiveSystemCount == 0"></el-badge>
              </el-dropdown-item>
              <!-- <el-dropdown-item command="message" v-if="componentShowMap.showChatRoom">
                私信
                <el-badge is-dot :value="userReceiveMessageCount" class="item"
                  :hidden="userReceiveMessageCount == 0"></el-badge>
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown @command="handleCommand" class="userInfoAvatar" trigger="hover" placement="bottom">
            <span class="el-dropdown-link avatar-container">
              <img v-if="!isLogin" src="../../static/images/defaultAvatar.png" />
              <img :class="userInfo.userTag > 0 ? 'vip-color' : ''" v-if="isLogin && userInfo.photoUrl != undefined"
                :src="userInfo.photoUrl" onerror="onerror=null;src=defaultAvatar" />
              <img v-if="isLogin && userInfo.photoUrl == undefined" :src="defaultAvatar" />
              <span class="vip-badge-main" data-vip="MAX" v-if="isLogin && userInfo.userTag === 19">V</span>
              <span class="vip-badge-main" data-vip="VIP" v-else-if="isLogin && userInfo.userTag === 16 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
              <span class="vip-badge-main" data-vip="SVIP" v-else-if="isLogin && userInfo.userTag === 17 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
              <span class="vip-badge-main" data-vip="SSVIP" v-else-if="isLogin && userInfo.userTag === 18 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
            </span>

            <el-dropdown-menu slot="dropdown" class="userDropdownMenu">
              <el-dropdown-item command="login" v-show="!isLogin" class="userDropdownMenuItem">
                <el-card :body-style="{ padding: '20px' }" style="width: 280px" class="cardStyle" v-if="!isLogin">
                  <el-row class="loginText">
                    <span>登录网站，可立即获得以下权益：</span>
                  </el-row>
                  <el-row class="loginSummary" :span="24">
                    <el-col :span="12">
                      <span class="iconfont">&#xe606;</span>&nbsp;收藏有用内容
                    </el-col>
                    <el-col :span="12">
                      <span class="iconfont">&#xe606;</span>&nbsp;阅读优质专栏
                    </el-col>
                  </el-row>
                  <el-row class="loginSummary" :span="24">
                    <el-col :span="12">
                      <span class="iconfont">&#xe606;</span>&nbsp;进行评论互动
                    </el-col>
                    <el-col :span="12">
                      <span class="iconfont">&#xe606;</span>&nbsp;提升成长等级
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-button type="primary" style="width: 100%; margin-top: 20px">立即登录
                    </el-button>
                  </el-row>
                </el-card>
              </el-dropdown-item>

              <el-dropdown-item v-show="isLogin" class="userDropdownMenuItem">
                <div class="user-hover-card">
                  <!-- 头部信息 -->
                  <div class="user-card-header">
                    <div class="user-avatar-section">
                      <el-avatar
                        :size="40"
                        :src="userInfo.photoUrl"
                        @click.native="getUserCenter('1')"
                        style="cursor: pointer">
                        <img :src="defaultAvatar" />
                      </el-avatar>
                      <span class="vip-badge-right" data-vip="MAX" v-if="userInfo.userTag === 19">V</span>
                      <span class="vip-badge-right" data-vip="VIP" v-else-if="userInfo.userTag === 16 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
                      <span class="vip-badge-right" data-vip="SVIP" v-else-if="userInfo.userTag === 17 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
                      <span class="vip-badge-right" data-vip="SSVIP" v-else-if="userInfo.userTag === 18 && userInfo.vipDeadlineTime && new Date(userInfo.vipDeadlineTime) > new Date()">V</span>
                    </div>
                    <div class="user-info-section">
                      <div class="user-name-row">
                        <span class="nickname" @click="getUserCenter('1')">{{ userInfo.nickName }}</span>
                        <!-- 男性图标 -->
                        <span class="gender-icon iconfont" v-if="userInfo.gender === '1' || userInfo.gender === 1" style="color: #409EFF;">&#xe641;</span>
                        <!-- 女性图标 -->
                        <span class="gender-icon iconfont" v-if="userInfo.gender === '2' || userInfo.gender === 2" style="color: #F56C6C;">&#xe643;</span>
                      </div>
                      <div class="user-level-row">
                        <span class="user-summary">{{ userInfo.summary || "这家伙很懒，什么都没有留下" }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 功能按钮区域 -->
                  <div class="user-actions">
                    <div class="action-item" @click="handleCommand('goUserCenter')">
                      <i class="el-icon-house"></i>
                      <span>个人主页</span>
                    </div>
                    <div class="action-item" @click="handleCommand('goCreateCenter')">
                      <i class="el-icon-edit"></i>
                      <span>创作中心</span>
                    </div>
                    <div class="action-item" @click="handleCommand('goUserInfo')">
                      <i class="el-icon-user"></i>
                      <span>个人中心</span>
                    </div>
                    <div class="action-item" @click="handleCommand('certification')">
                      <i class="el-icon-document-checked"></i>
                      <span>信息认证</span>
                    </div>
                    <div class="action-item" @click="handleCommand('vip')">
                      <i class="el-icon-star-on"></i>
                      <span>会员中心</span>
                    </div>
                    <div class="action-item" @click="handleCommand('messages')">
                      <i class="el-icon-message"></i>
                      <span>消息中心</span>
                    </div>
                  </div>

                  <!-- 底部退出 -->
                  <div class="user-card-footer">
                    <div class="logout-btn" @click="handleCommand('logout')">
                      <i class="el-icon-switch-button"></i>
                      <span>退出登录</span>
                    </div>
                  </div>
                </div>
              </el-dropdown-item>

              <!--            <el-dropdown-item command="goUserCenter" v-show="isLogin">我的主页</el-dropdown-item>-->
              <!--            <el-dropdown-item command="goUserInfo" v-show="isLogin">个人中心</el-dropdown-item>-->
              <!--            <el-dropdown-item command="logout" v-show="isLogin">退出登录</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
        </nav>
      </header>

      <WebNotice></WebNotice>

      <!--登录框-->
      <LoginBox v-if="showLogin" @closeLoginBox="closeLoginBox"></LoginBox>

      <!--勋章-->
      <Medal ref="medal"></Medal>





      <div :style="{ 'min-height': minHeight + 'px' }" >
        <router-view />
      </div>

      <!-- 页脚区域 - 参考ITMarket.vue的设计 -->
      <footer class="site-footer">
        <div class="footer-container">
          <div class="footer-row">
            <!-- 左侧区域：联系信息 -->
            <div class="footer-left">
              <div class="contact-item">
                <i class="el-icon-phone"></i>
                <span>客服邮箱: itgetjob@126.com</span>
              </div>
              <div class="contact-item">
                <i class="el-icon-time"></i>
                <span>工作时间: 9:00-22:00</span>
              </div>
            </div>

            <!-- 中间区域：备案信息 -->
            <div class="footer-center">
              <div class="beian-info">
                <a href="http://beian.miit.gov.cn/" target="_blank" class="beian-item">津ICP备2025030906号</a>
                &nbsp;&nbsp;&nbsp;
                <span class="beian-item">津公网安备12011202001014号</span>
                <span class="beian-item with-link">
                  <i class="el-icon-warning-outline"></i>
                </span>
              </div>
            </div>

            <!-- 右侧区域：版权和政策链接 -->
            <div class="footer-right">
              <div class="social-links">
                <a href="javascript:;" class="social-icon"><i class="el-icon-s-custom"></i></a>
                <a href="javascript:;" class="social-icon"><i class="el-icon-chat-dot-round"></i></a>
                <a href="javascript:;" class="social-icon"><i class="el-icon-bell"></i></a>
              </div>
              <div class="copyright">
                ©2025-forevery    www.itgetjob.com
              </div>
            </div>
          </div>
        </div>
      </footer>


        <div>

          <!--顶部模式-->
          <a href="javascript:void(0);" @click="returnTop" :class="isCdTopVisible ? 'cd-top cd-is-visible' : 'cd-top'">
            <span style="font-size: 26px" class="iconfont">&#xe6fb;</span>
          </a>
        </div>
    </body>

    </html>
  </div>
</template>

  <script>

  import { getWebConfig, getWebNavbar } from "../api/index";
  import { delCookie, getCookie, setCookie } from "@/utils/cookieUtils";
  import config from "../../conf.json";
  import {
    authVerify,
    deleteUserAccessToken,
  } from "../api/user";
  import {
    getUserReceiveNoticeCount,
    readUserReceiveNoticeCount,
  } from "../api/notice";
  import LoginBox from "../components/LoginBox";
  import Medal from "../components/Medal";
  import WebNotice from "../components/WebNotice";
  import { mapMutations } from "vuex";
  import { getSearchModel } from "@/api/search";
  import { addHotSearch, getHotSearchList } from "../api/hotSearch";
  import webSocketManager from '@/utils/WebSocketManager';

  export default {
    name: "index",
    components: {
      Medal,
      LoginBox,
      WebNotice,
    },
    data() {
      return {
        // xss白名单配置
        options: {
          whiteList: {
            div: ["class"],
            br: ["class"],
            a: ["href", "title", "target"],
            span: ["class"],
            h1: ["class"],
            h2: ["class"],
            h3: ["class"],
            h4: ["class"],
            h5: ["class"],
            h6: ["class"],
            pre: [],
            code: ["class"],
            p: ["class"],
            ol: [],
            blockquote: ["class"],
            ul: ["class"],
            li: ["class"],
            img: ["class", "src", "alt", "width", "height", "style"],
            iframe: [
              "class",
              "src",
              "style",
              "scrolling",
              "border",
              "frameborder",
              "allowfullscreen",
            ],
            hr: [],
            video: ["class", "src", "controls"],
            source: ["src", "type"],
          },
        },
        defaultConfig: {}, // 全局默认配置
        webConfig: {},
        minHeight: window.screen.height - 273,
        searchModel: 0, // 搜索模式 0:SQL搜索、1:ES搜索、2:Solr搜索

        webSite: process.env.VUE_ITGETJOB_WEB,
        webNavbarList: [],
        info: {},
        saveTitle: "",
        keyword: "",
        showSearch: false, // 控制搜索框的弹出
        showHead: false, // 控制导航栏的弹出
        isCdTopVisible: false,
        isVisible: true, // 控制web端导航的隐藏和显示
        isLogin: false,
        showLogin: false, // 显示登录框
        userInfo: {
          // 用户信息
        },
        icon: false, // 控制删除图标的显示
        defaultAvatar: process.env.defaultAvatar, // 默认头像
        userReceiveCommentCount: 0, // 用户收到的评论数
        userReceivePraiseCount: 0, // 用户收到的点赞数
        userReceiveSystemCount: 0, // 用户收到的系统通知数
        userReceiveWatchCount: 0, // 用户收到的关注数
        userReceiveMessageCount: 0, // 用户收到的消息数
        userReceiveCollectCount: 0, // 用户收到的收藏数
        componentShowMap: {}, // 组件展示Map
        browserFlag: 1, // 浏览器标志【默认Chrome】
        darkModel: 0, // 暗黑模式 是否开启
        dialogHotSearchVisible: false,
        hotSearchList: [], // 热搜列表数据

        leaveTimeout: null, // 离开定时器
        authCode: {}, // 用户权限Code
      };
    },
    mounted() {
      let that = this;
      let offset = 300;
      let after = 0;
      window.addEventListener("scroll", function () {
        let scrollTop = document.documentElement.scrollTop; // 当前的的位置
        let scrollHeight = document.documentElement.scrollHeight; // 最高的位置
        if (scrollTop > offset) {
          that.isCdTopVisible = true;
        } else {
          that.isCdTopVisible = false;
        }
        after = scrollTop;
      });

      // 屏幕自适应
      window.onresize = () => {
        return (() => {
          that.setSize();
        })();
      };
    },

    watch: {
      $route(to, from) {
        this.getCurrentPageTitle();
      },
      "$store.state.user.userInfo": function (newFlag, oldFlag) {
        this.getUserAuthCodeList();
      },

      // 判断登录状态位是否改变（用于控制弹框）
      "$store.state.app.loginMessage": function (newFlag, oldFlag) {
        this.showLogin = true;
      },
    },
    metaInfo() {
      return {
        title: this.info.title ? this.info.title : config.title,
        // link: [{ rel: "icon", href: this.info.logoPhoto }], // 移除动态favicon设置，使用默认favicon.ico
        meta: [],
      };
    },
    created() {
      this.getToken();
      this.getKeyword();
      this.getCurrentPageTitle();
      this.getWebConfigInfo();
      this.getWebNavbarList();
      this.setSize();
      this.setUserReceiveCommentCount();
      // 获取浏览器类型
      this.getBrowser();
      // 获取搜索模式
      this.getBlogSearchModel();
      // 注册WebSocket消息处理器
      this.registerWebSocketHandlers();
      // 初始化暗黑模式
      this.initDarkModel();
      // 设置配置信息
      this.defaultConfig = config;
    },
    destroyed() {
      // 移除WebSocket消息处理器
      this.unregisterWebSocketHandlers();
    },
    methods: {
      // 拿到vuex中的写的方法
      ...mapMutations([
        "setUserInfo",
        "setLoginState",
        "setWebConfigData",
        "setNoticeType",
        "setAuthCode",
      ]),
      initDarkModel() {
        // 暗黑模式
        let darkModel = getCookie("darkModel");
        if (darkModel && darkModel == "1") {
          this.darkModel = 1;
          window.document.documentElement.setAttribute("data-theme", "dark");
        } else {
          this.darkModel = 0;
          window.document.documentElement.setAttribute("data-theme", "light");
        }
      },


      /**
       * 注册WebSocket消息处理器
       */
      registerWebSocketHandlers() {
        // 监听所有消息，但在处理函数中过滤，只处理领域事件
        webSocketManager.onMessage('*', this.handleDomainEvent, 'home-domain-event')
      },
      
      /**
       * 移除WebSocket消息处理器
       */
      unregisterWebSocketHandlers() {
        webSocketManager.offMessage('*', 'home-domain-event')
      },
      
      /**
       * 处理领域事件
       */
      handleDomainEvent(messageVo) {
        // 只处理领域事件，忽略聊天消息（category: 20001）
        if (messageVo.messageLevel && messageVo.messageLevel === 40010) {
          console.log('home接收领域事件', messageVo)
          console.log('处理领域事件', messageVo)
          
          switch (messageVo.message) {
            case 'MEDAL_AWARD':
              {
                console.log('勋章奖励')
                // 勋章奖励，刷新
                if (this.$refs.medal) {
                  this.$refs.medal.getUserMedal()
                }
              }
              break
            case 'NOTICE_FLUSH':
              {
                // 刷新通知
                console.log('刷新通知')
                // 这里可以添加刷新通知的具体逻辑
              }
              break
            case 'COMMENT_NOTICE':
              {
                // 评论通知
                console.log('收到评论通知')
                this.setUserReceiveCommentCount()
                // this.$message({
                //   message: '您收到了新的评论',
                //   type: 'info',
                //   duration: 3000
                // })
              }
              break
            case 'FOLLOW_NOTICE':
              {
                // 关注通知
                console.log('收到关注通知')
                // this.$message({
                //   message: '有人关注了您',
                //   type: 'success',
                //   duration: 3000
                // })
                this.setUserReceiveCommentCount()
              }
              break
            case 'PAY_SUCCESS':
              {
                // 支付成功，刷新用户信息
                console.log('home收到支付成功通知，刷新用户信息')
                this.refreshUserInfo()
              }
              break
          }
        }
        // 对于聊天消息（category: 20001），不做任何处理，避免干扰ChatPopup
      },
      showHotSearch: function () {
        this.dialogHotSearchVisible = true;
        // 如果热搜数据为空，则获取数据
        if (this.hotSearchList.length === 0) {
          this.getHotSearchData();
        }
      },

      // 处理输入框失焦事件
      handleInputBlur: function() {
        // 延迟隐藏，给点击事件足够的时间
        setTimeout(() => {
          this.dialogHotSearchVisible = false;
        }, 200);
      },

      // 获取热搜数据
      getHotSearchData: function() {
        getHotSearchList().then((result) => {
          if (result.code == this.$ECode.SUCCESS && result.data && result.data.length > 0) {
            this.hotSearchList = result.data;
          } else {
            // 如果API返回空数据，使用默认数据
            this.hotSearchList = [
              { uid: '1', content: 'Vue3响应式原理' },
              { uid: '2', content: 'JavaScript异步编程' },
              { uid: '3', content: 'React Hooks详解' },
              { uid: '4', content: 'TypeScript入门教程' },
              { uid: '5', content: 'Node.js后端开发' },
              { uid: '6', content: 'CSS Grid布局' },
              { uid: '7', content: 'Webpack配置优化' },
              { uid: '8', content: 'ES6新特性详解' }
            ];
          }
        }).catch(() => {
          // 如果API失败，使用默认数据
          this.hotSearchList = [
            { uid: '1', content: 'Vue3响应式原理' },
            { uid: '2', content: 'JavaScript异步编程' },
            { uid: '3', content: 'React Hooks详解' },
            { uid: '4', content: 'TypeScript入门教程' },
            { uid: '5', content: 'Node.js后端开发' },
            { uid: '6', content: 'CSS Grid布局' },
            { uid: '7', content: 'Webpack配置优化' },
            { uid: '8', content: 'ES6新特性详解' }
          ];
        });
      },

      // 选择热搜项
      selectHotSearch: function (searchTerm) {
        console.log('选择热搜项:', searchTerm);
        this.keyword = searchTerm;
        this.dialogHotSearchVisible = false;
        // 使用 $nextTick 确保 keyword 更新后再执行搜索
        this.$nextTick(() => {
          console.log('搜索关键词:', this.keyword);
          this.search();
        });
      },
      // 搜索
      search: function () {
        if (this.keyword == "" || this.keyword.trim() == "") {
          this.$notify.error({
            title: "错误",
            message: "关键字不能为空",
            type: "error",
            offset: 100,
          });
          return;
        }
        addHotSearch(this.keyword).then((result) => {
          if (result.code == this.$ECode.SUCCESS) {
          }
        });
        if (this.$route.path == "/userCenter") {
          this.$router.push({
            path: this.$route.fullPath,
            query: { keyword: this.keyword, model: this.searchModel },
          });
        } else {
          this.$router.push({
            path: "/list",
            query: { keyword: this.keyword, model: this.searchModel },
          });
        }
      },
      // 跳转到创作页面
      goToCreatePage(path) {
        window.open(this.$router.resolve(path).href, '_blank');
      },
      // 导航方法 - 统一处理路由跳转（与ITMarket一致）
      navigateTo(path, query = {}) {
        if (path) {
          let routeData = this.$router.resolve({
            path: path,
            query: query
          });
          this.safeWindowOpen(routeData.href);
        }
      },
      // 安全地打开新窗口，处理浏览器阻止弹窗的情况
      safeWindowOpen(url, target = '_blank') {
        try {
          const newWindow = window.open(url, target);
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            // 弹窗被阻止，提示用户
            this.$message.warning('浏览器阻止了弹窗，请允许弹窗或手动打开链接');
            console.warn('弹窗被阻止:', url);
          }
          return newWindow;
        } catch (error) {
          console.error('打开新窗口失败:', error);
          this.$message.error('打开页面失败，请稍后重试');
          return null;
        }
      },
      changeDarkModel(darkModel) {
        if (darkModel == 1) {
          console.log("切换暗黑模式");
          window.document.documentElement.setAttribute("data-theme", "dark");
        } else {
          console.log("切换亮白模式");
          window.document.documentElement.setAttribute("data-theme", "light");
        }
        // 设置暗黑模式
        setCookie("darkModel", darkModel, 31);
        this.darkModel = darkModel;
      },

      clickWebNavbar: function (webNavbar) {
        if (this.info.title && webNavbar.name && webNavbar.isJumpExternalUrl == 0) {
          document.title = this.info.title + " | " + webNavbar.name;
        }
      },

      getBlogSearchModel: function () {
        getSearchModel().then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            this.searchModel = response.data;
          }
        });
      },
      setSize() {
        // 屏幕大于950px的时候，显示侧边栏
        let clientWidth = document.body.clientWidth;
        if (clientWidth > 1360) {
          this.drawerSize = "33%";
          this.showSearch = true;
        } else if (clientWidth < 1360 && clientWidth > 950) {
          this.drawerSize = "50%";
          this.showSearch = false;
        } else if (clientWidth < 950 && clientWidth > 650) {
          this.drawerSize = "70%";
          this.showSearch = false;
        } else {
          this.drawerSize = "95%";
          this.showSearch = false;
        }
      },


      // 跳转到创作中心
      goToCreatedCenter() {
        let routeData = this.$router.resolve({
          path: "/createdCenter/index",
        });
        window.open(routeData.href, "_blank");
      },
      // 跳转到个人中心页
      getUserCenter: function (blog) {
        console.log("跳转到用户中心", blog);
        // 判断是后台添加，还是前台投稿
        // if (blog.articleSource == 0) {
        //   let routeData = this.$router.resolve({
        //     path: "/userCenter",
        //     query: { adminUid: blog.adminUid },
        //   });
        //   window.open(routeData.href, "_blank");
        // } else {
        //   let routeData = this.$router.resolve({
        //     path: "/userCenter",
        //     query: { userUid: blog.userUid },
        //   });
        //   window.open(routeData.href, "_blank");
        // }

        window.open('/engineerdetail/' + this.userInfo.uid, '_blank');

      },

      // 获取导航栏列表
      getWebNavbarList() {
        let params = {};
        params.isShow = 1;
        getWebNavbar(params).then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            let webNavbarList = response.data;
            let newWebNavbarList = [];
            for (let a = 0; a < webNavbarList.length; a++) {
              if (webNavbarList[a].isShow == 1) {
                newWebNavbarList.push(webNavbarList[a]);
              }
            }
            this.webNavbarList = newWebNavbarList;
          }
        });
      },










      /**
       * dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
       * @param dateTimeStamp
       * @returns {string}
       */
      timeAgo(dateTimeStamp) {
        return timeAgo(dateTimeStamp);
      },




      onCardEnterTd: function () {
        clearTimeout(this.leaveTimeout);
      },
      // 鼠标离开的事件。
      onLeaveTd(nowClean) {
        console.log("触发离开配置");
        let that = this;
        if (nowClean) {
          that.dialogHotSearchVisible = false;
        } else {
          this.leaveTimeout = setTimeout(() => {
            that.dialogHotSearchVisible = false;
          }, 500);
        }
      },




      getToken: function () {
        let token = this.getUrllets()["token"];
        // 判断url中是否含有token
        if (token) {
          // 设置token 31天过期
          setCookie("token", token, 31);
          // 如何清空url中某个字段
          let url = window.location.href;
          let replaceUrl = this.$commonUtil.ridUrlParam(url, ["token"]);
          // 替换url不刷新
          history.replaceState(null, null, replaceUrl);
        } else {
          // 从cookie中获取token
          token = getCookie("token");
        }
        // 从url和cookie中获取token，在去校验
        if (token) {
          authVerify(token).then((response) => {
            if (response && response.code == this.$ECode.SUCCESS) {
              this.isLogin = true;
              this.userInfo = response.data;
              // 调试输出用户信息，特别是gender字段
              console.log('用户信息:', this.userInfo);
              console.log('用户性别:', this.userInfo.gender, '类型:', typeof this.userInfo.gender);
              // 获取用户标识
              let userTag = this.userInfo.userTag;
              this.setUserInfo(this.userInfo);
            } else {
              this.isLogin = false;
              delCookie("token");
            }
            this.setLoginState(this.isLogin);
            // 获取原页面地址，登录后进行跳转到原页面，如果为空或者就是在首页登录，不进行跳转
            const redirectUrl = getCookie("redirectUrl");
            if (
              redirectUrl != undefined &&
              redirectUrl != "" &&
              redirectUrl != "/"
            ) {
              window.location.href = redirectUrl;
              // 清除缓存的原页面地址
              delCookie("redirectUrl");
            }
          });

          // 最后在
        } else {
          this.isLogin = false;
          this.setLoginState(this.isLogin);
        }
      },



      setUserReceiveCommentCount: function () {
        getUserReceiveNoticeCount().then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            this.userReceiveCommentCount = response.data.userReceiveCommentCount;
            this.userReceivePraiseCount = response.data.userReceivePraiseCount;
            this.userReceiveSystemCount = response.data.userReceiveSystemCount;
            this.userReceiveWatchCount = response.data.userReceiveWatchCount;
            this.userReceiveMessageCount = response.data.userReceiveMessageCount;
            this.userReceiveCollectCount = response.data.userReceiveCollectCount;
          }
        });
      },
      getKeyword: function () {
        let tempValue = decodeURI(this.getUrllets()["keyword"]);
        if (
          tempValue == null ||
          tempValue == undefined ||
          tempValue == "undefined"
        ) {
        } else {
          this.keyword = tempValue;
        }
      },
      /**
       * 获取当前所在页面的标题
       * @returns {{}}
       */
      getCurrentPageTitle: function () {
        // 判断是否是通过参数传递的title
        let title = this.getUrllets()["title"];
        console.log("获取url", title);
        if (title) {
          // 如果是通过参数传递，那么直接显示
          this.saveTitle = title;
        } else {
          // 从url中获取title
          let test = window.location.href;
          let start = 0;
          let end = test.length;
          for (let i = 0; i < test.length; i++) {
            if (test[i] == "/") {
              start = i;
            }
            if (test[i] == "?" && i > start) {
              end = i;
            }
          }
          let result = test.substring(start, end);
          this.saveTitle = result;
        }
      },
      /**
       * 获取网站配置
       */
      getWebConfigInfo: function () {
        let webConfigData = this.$store.state.app.webConfigData;
        if (webConfigData.createTime) {
          this.contact = webConfigData;
          this.mailto = "mailto:" + this.contact.email;
          document.title = this.info.title;
          this.componentShowMap = webConfigData.componentShowMap;
        } else {
          getWebConfig().then((response) => {
            if (response.code == this.$ECode.SUCCESS) {
              this.info = response.data;
              // 存储在Vuex中
              this.setWebConfigData(response.data);
              document.title = this.info.title;
              this.componentShowMap = this.info.componentShowMap;
            }
          });
        }
      },
      // 获取用户权限码
      getUserAuthCodeList() {
        let userInfo = this.$store.state.user.userInfo;
        if (userInfo) {
          let authCode = this.$commonUtil.InitUserAuthCode(userInfo.authCodeList);
          this.setAuthCode(authCode);
          this.authCode = authCode;
        }
      },
      /**
       * 截取URL中的参数
       * @returns {{}}
       */
      getUrllets: function () {
        let lets = {};
        let url = window.location.href;
        url = decodeURI(url);
        let parts = url.replace(
          /[?&]+([^=&]+)=([^&#]*)/gi,
          function (m, key, value) {
            lets[key] = value;
          },
        );
        return lets;
      },


      openHead: function () {
        this.showHead = !this.showHead;
      },
      returnTop: function () {
        window.scrollTo(0, 0);
      },
      userLogin: function () {
        this.showLogin = true;
      },
      userLogout: function () {
        deleteUserAccessToken(getCookie("token"));
        delCookie("token");
        let url = window.parent.location.href;
        let haveToken = url.indexOf("?token");
        if (haveToken != -1) {
          let list = url.split("?token");
          this.isLogin = false;
          window.location.href = list[0];
          let userInfo = {};
          this.setUserInfo(userInfo);
        } else {
          window.location.reload();
        }
      },

      // 点击头像触发的动作
      handleCommand(command) {
        switch (command) {



          case "logout":
            {
              this.userLogout();
            }
            break;
          case "login":
            {
              this.userLogin();
            }
            break;
          case "goUserCenter":
            {
              // 检查是否登录
              if (!this.isLogin) {
                this.$message.warning('请先登录');
                this.showLogin = true;
                return;
              }
              this.navigateTo('/userCenter', { userUid: this.userInfo.uid });
            }
            break;
          case "goCreateCenter":
            {
              // 检查是否登录
              if (!this.isLogin) {
                this.$message.warning('请先登录');
                this.showLogin = true;
                return;
              }
              this.navigateTo('/createdCenter/index');
            }
            break;
          case "goUserInfo":
            {
              // 检查是否登录
              if (!this.isLogin) {
                this.$message.warning('请先登录');
                this.showLogin = true;
                return;
              }
              this.navigateTo('/user-center');
            }
            break;
          case "certification":
            {
              // 检查是否登录
              if (!this.isLogin) {
                this.$message.warning('请先登录');
                this.showLogin = true;
                return;
              }
              this.navigateTo('/authentication');
            }
            break;
          case "messages":
            {
              // 检查是否登录
              if (!this.isLogin) {
                this.$message.warning('请先登录');
                this.showLogin = true;
                return;
              }
              this.$router.push({ path: "/notice", query: { noticeType: "4" } });
            }
            break;
          case "vip":
            {
              this.navigateTo('/vip');
            }
            break;
          case "medal":
            {
              this.$router.push({
                path: "/medal/" + this.userInfo.uid,
              });
            }
            break;
          case "userMoment":
            {
              this.$router.push({ path: "/moment" });
            }
            break;
          case "comment":
            {
              if (!this.isLogin) {
                this.showLogin = true;
                return;
              }
              // 判断用户是否未读的回复
              if (this.userReceiveCommentCount > 0) {
                // 设置已阅读
                let params = {};
                params.noticeType = "1";
                this.readNotice();
                this.userReceiveCommentCount = 0;
              }
              this.setNoticeType("1");
              this.$router.push({ path: "/notice", query: { noticeType: "1" } });
            }
            break;
          case "watch":
            {
              if (!this.isLogin) {
                this.showLogin = true;
                return;
              }
              // 设置已阅读
              let params = {};
              params.noticeType = "2";
              if (this.userReceiveWatchCount > 0) {
                this.readNotice();
                this.userReceiveWatchCount = 0;
              }
              this.setNoticeType("2");
              this.$router.push({ path: "/notice", query: { noticeType: "2" } });
            }
            break;
          case "praise":
            {
              if (!this.isLogin) {
                this.showLogin = true;
                return;
              }
              // 设置已阅读
              let params = {};
              params.noticeType = "3";
              if (this.userReceivePraiseCount > 0) {
                this.readNotice();
                this.userReceivePraiseCount = 0;
              }
              this.setNoticeType("3");
              this.$router.push({ path: "/notice", query: { noticeType: "3" } });
            }
            break;
          case "system":
            {
              if (!this.isLogin) {
                this.showLogin = true;
                return;
              }
              // 设置已阅读
              let params = {};
              params.noticeType = "4";
              if (this.userReceiveSystemCount > 0) {
                this.readNotice();
                this.userReceiveSystemCount = 0;
              }
              this.setNoticeType("4");
              this.$router.push({ path: "/notice", query: { noticeType: "4" } });
            }
            break;
          case "collect":
            {
              if (!this.isLogin) {
                this.showLogin = true;
                return;
              }
              // 设置已阅读
              let params = {};
              params.noticeType = "6";
              if (this.userReceiveCollectCount > 0) {
                this.readNotice();
                this.userReceiveCollectCount = 0;
              }
              this.setNoticeType("6");
              this.$router.push({ path: "/notice", query: { noticeType: "6" } });
            }
            break;
          case "message":
            {
              this.goChat();
            }
            break;
          case "openVip":
            {
              this.$router.push({ path: "/vip" });
            }
            break;
        }
      },
      goChat() {
        if (!this.isLogin) {
          this.showLogin = true;
          return;
        }
        // 设置已阅读
        let params = {};
        params.noticeType = "5";
        if (this.userReceiveMessageCount > 0) {
          this.readNotice();
          this.userReceiveMessageCount = 0;
        }
        this.$router.push({ path: "/chat" });
      },
      readNotice() {
        readUserReceiveNoticeCount().then((response) => {
          if (response.code == this.$ECode.SUCCESS) {
            // 阅读成功，清零所有消息计数
            this.userReceiveCommentCount = 0;
            this.userReceivePraiseCount = 0;
            this.userReceiveSystemCount = 0;
            this.userReceiveWatchCount = 0;
            this.userReceiveMessageCount = 0;
            this.userReceiveCollectCount = 0;
            console.log('消息已标记为已读，计数已清零');
          }
        }).catch(error => {
          console.error('标记消息已读失败:', error);
        });
      },
      closeLoginBox: function () {
        this.showLogin = false;
      },
      // 获取浏览器类型, 用于兼容处理
      getBrowser() {
        let sBrowser,
          sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Firefox") > -1) {
          sBrowser = "Mozilla Firefox";
          this.browserFlag = 2;
          // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf("Chrome") > -1) {
          sBrowser = "Google Chrome or Chromium";
          this.browserFlag = 1;
          // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        }
      },
      fenToYuanNumber(amount) {
        return amount / 100;
      },
      /**
       * 刷新用户信息
       */
      refreshUserInfo() {
        const token = getCookie("token");
        if (!token) {
          console.warn("[refreshUserInfo] token不存在，无法刷新用户信息");
          return;
        }
        
        console.log("[refreshUserInfo] 开始刷新用户信息");
        
        // 重新验证token并获取最新用户信息
        import('../api/user.js').then(({ authVerify }) => {
          authVerify(token).then(response => {
            if (response && response.code === this.$ECode.SUCCESS) {
              const userInfo = response.data;
              
              // 验证会员状态
              if (userInfo.vipDeadlineTime) {
                const now = new Date();
                const deadlineTime = new Date(userInfo.vipDeadlineTime);
                userInfo.isVip = deadlineTime > now;
                console.log('[refreshUserInfo] 会员状态检查:', '截止时间:', userInfo.vipDeadlineTime, '是否会员:', userInfo.isVip);
              } else {
                userInfo.isVip = false;
                console.log('[refreshUserInfo] 会员状态检查: 无截止时间，非会员');
              }
              
              // 更新全局用户信息
              this.$store.commit('setUserInfo', userInfo);
              this.$store.commit('setLoginState', true);
              
              // 更新本地用户信息
              this.userInfo = userInfo;
              this.isLogin = true;
              
              console.log("[refreshUserInfo] 用户信息刷新完成:", userInfo);
              
              this.$message.success('会员状态已更新！');
            } else {
              console.error("[refreshUserInfo] 获取用户信息失败:", response);
              this.$message.warning('用户信息刷新失败');
            }
          }).catch(error => {
            console.error("[refreshUserInfo] 刷新用户信息异常:", error);
            this.$message.warning('用户信息刷新失败');
          });
        });
      },
    },
  };
</script>

  <style>
  @import "../assets/css/emoji.css";

  #login_container iframe {
    height: 450px;
  }

  .emoji-panel-btn:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .emoji-item-common {
    background: url("../assets/img/emoji_sprite.png");
    display: inline-block;
    zoom: 0.3;
  }

  .emoji-item-common:hover {
    cursor: pointer;
  }

  .emoji-size-small {
    zoom: 0.3;
  }
</style>

  <style scoped>
  ::v-deep .el-timeline-item__timestamp {
    font-size: 14px;
    font-weight: 600;
    color: rgb(23, 35, 63);
  }

  .userDropdownMenuItem {
    padding: 0 0;
  }

  .userDropdownMenu {
    padding: 0 0;
  }

  .isEnd {
    float: left;
    width: 100%;
    height: 80px;
    text-align: center;
  }

  .loadContent {
    border-radius: 25px;
    width: 120px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    margin: 0 auto;
    color: aliceblue;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.8);
  }

  .createBlog {
    position: absolute;
    top: 16px;
    right: -20px;
  }

  .el-tag {
    height: 25px;
    line-height: 25px;
    margin-left: 6px;
  }

  #starlist li .title {
    color: #007fff;
  }

  /* 现代化搜索栏样式 */
  .modern-search-container {
    position: absolute;
    right: 300px;
    top: 0;
    display: flex;
    flex-direction: column;
    z-index: 100;
  }

  .search-wrapper {
    position: relative;
    width: 320px;
    height: 60px;
    display: flex;
    align-items: center;
  }

  .search-input-group {
    position: relative;
    width: 100%;
    height: 36px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 18px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .search-input-group:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  }

  .search-input-group:focus-within {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  .search-icon {
    margin-left: 12px;
    margin-right: 8px;
    color: #c0c4cc;
    font-size: 16px;
    transition: color 0.3s ease;
  }

  .search-input-group:focus-within .search-icon {
    color: #409eff;
  }

  .search-input {
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #606266;
    padding: 0 8px 0 0;
  }

  .search-input::placeholder {
    color: #c0c4cc;
    font-size: 14px;
  }

  .search-button {
    width: 32px;
    height: 32px;
    background: #409eff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 2px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .search-button:hover {
    background: #66b1ff;
    transform: scale(1.05);
  }

  .search-button i {
    color: white;
    font-size: 14px;
  }

  .create {
    width: 35px;
    height: 40px;
    position: absolute;
    right: 200px;
  }

  .notice {
    width: 35px;
    height: 35px;
    position: absolute;
    font-size: 24px;
    margin-top: 2px;
    right: 90px;
    cursor: pointer;
  }

  .vipIcon {
    width: 35px;
    position: absolute;
    right: 135px;
    top: 16px;
    height: 30px;
  }

  .vip-entry-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
  }

  .crown-vip-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    transform: scale(1.05);
  }

  .crown-vip-icon:hover {
    transform: scale(1.15);
    filter: drop-shadow(0 4px 8px rgba(255, 140, 0, 0.4));
  }

  .vipIcon img {
    width: 30px;
    height: 30px;
  }

  .userInfoAvatar {
    width: 35px;
    height: 35px;
    position: absolute;
    right: 40px;
    top: 12px;
  }

  .userInfoAvatar img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }

  .el-icon-bell:hover {
    color: #00ccff;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    margin: 0, 0, 0, 10px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .imgBody {
    width: 100px;
    height: 100px;
    border: solid 2px #ffffff;
    float: left;
    position: relative;
  }

  .imgBody img {
    width: 100px;
    height: 100px;
  }

  .uploadImgBody {
    margin-left: 5px;
    width: 100px;
    height: 100px;
    border: dashed 1px #c0c0c0;
    float: left;
    position: relative;
  }

  .uploadImgBody :hover {
    border: dashed 1px #00ccff;
  }

  .inputClass {
    position: absolute;
  }

  .commentList {
    width: 100%;
    margin: 0 auto;
  }

  .commentList .p1 {
    float: left;
  }

  .commentList .left {
    display: inline-block;
    width: 10%;
    height: 100%;
  }

  .commentList .left img {
    margin: 0 auto;
    width: 100%;
    border-radius: 50%;
  }

  .commentList .right {
    display: inline-block;
    width: 85%;
    margin-left: 5px;
  }

  .commentList .rightTop {
    height: 30px;
  }

  .commentList .rightTop .userName {
    color: #303133;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .commentList .rightTop .timeAgo {
    color: #909399;
    margin-left: 5px;
    font-size: 12px;
  }

  .commentList .rightCenter {
    margin-left: 20px;
    line-height: 30px;
    min-height: 60px;
  }

  .feedbackCard .item .title {
    display: inline-block;
    width: 70px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
  }

  .feedbackCard .item .content {
    display: inline-block;
    width: 240px;
    margin-bottom: 5px;
  }

  .myArticle .blogpic {
    float: left;
    max-height: 170px;
    margin-right: 20px;
    display: block;
    overflow: hidden;
  }

  .myArticle .blogpic img {
    width: 100%;
    max-height: 70px;
    -webkit-transition: all 0.6s ease;
    transition: all 0.6s ease;
    margin-bottom: 10px;
  }

  .myArticle .bloginfo {
    margin-top: 5px;
  }

  .myArticle .operation {
    float: right;
    margin-top: 3px;
    margin-left: 20px;
    height: 40px;
  }



  @media only screen and (min-width: 1346px) and (max-width: 1432px) {
    .modern-search-container {
      right: 360px;
    }

    .search-wrapper {
      width: 280px;
    }

    .create {
      right: 280px;
    }

    .notice {
      right: 200px;
    }

    .userInfoAvatar {
      right: 150px;
    }
  }

  @media only screen and (min-width: 1135px) and (max-width: 1345px) {
    .modern-search-container {
      right: 480px;
    }

    .search-wrapper {
      width: 260px;
    }

    .create {
      right: 420px;
    }

    .notice {
      right: 350px;
    }

    .userInfoAvatar {
      right: 300px;
    }
  }

  @media only screen and (min-width: 649px) and (max-width: 1134px) {
    .modern-search-container {
      right: 180px;
      top: -2px;
    }

    .search-wrapper {
      width: 200px;
      height: 56px;
    }

    .search-input-group {
      height: 32px;
    }

    .search-input {
      font-size: 13px;
    }

    .search-button {
      width: 28px;
      height: 28px;
      border-radius: 14px;
    }

    .create {
      right: 50px;
      display: none;
    }

    .notice {
      right: 100px;
      top: -2px;
    }

    .userInfoAvatar {
      width: 35px;
      height: 35px;
      position: absolute;
      right: 45px;
      top: 10px;
    }
  }

  @media only screen and (max-width: 649px) {
    .modern-search-container {
      right: 110px;
      top: -3px;
    }

    .search-wrapper {
      width: 160px;
      height: 52px;
    }

    .search-input-group {
      height: 30px;
      border-radius: 15px;
    }

    .search-input {
      font-size: 12px;
    }

    .search-input::placeholder {
      font-size: 12px;
    }

    .search-icon {
      margin-left: 10px;
      margin-right: 6px;
      font-size: 14px;
    }

    .search-button {
      width: 26px;
      height: 26px;
      border-radius: 13px;
    }

    .search-button i {
      font-size: 12px;
    }

    .create {
      right: 50px;
      display: none;
    }

    .notice {
      right: 45px;
      top: -4px;
    }

    .userInfoAvatar {
      width: 35px;
      height: 35px;
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .vipIcon {
      top: 12px;
      right: 75px;
    }
  }
</style>

  <style lang="scss">
  .codeContent {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 25vh;
  }

  .code-copy-added {
    background-color: #282c34;
    color: white;
    padding: 2px 2px;
    margin: 10px 0;
    text-align: left;
    border-radius: 3px;
    position: relative;
  }

  .code-copy-added:hover .copy-btn {
    opacity: 1;
  }

  .gainImg {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
  }

  .vipIconItem {
    text-align: center;
    margin-top: 5px;
  }

  .vipIconItem .icon {
    line-height: 40px;
  }

  .vipIconItem .title {
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    vertical-align: top;
  }

  .centerCard {
    line-height: 45px;
    height: 45px;
    text-align: center;

  }

  .centerCard .icon {

    color: rgba(37, 41, 51, 1);
    cursor: pointer;
  }

  .thin-stripe {
    background-image: linear-gradient(to right,
        transparent,
        #000 10%,
        #000 90%,
        transparent);
    background-size: 100% 2px;
    /* 根据需要调整高度 */
    background-repeat: no-repeat;
    height: 10px;
    /* 线条高度 */
  }

  .vipCardTitle {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 31.86px;
    color: rgba(255, 102, 0, 1);
    text-align: left;
    vertical-align: top;
  }

  .vipCardStyle {
    left: 1230px;
    top: 156px;
    width: 400px;
    opacity: 1;
    background: linear-gradient(180deg,
        rgba(255, 245, 230, 1) 0%,
        rgba(255, 252, 248, 1) 46.92%,
        rgba(255, 220, 191, 1) 100%);
  }

  .vipButton {
    border-radius: 19px;
    background: linear-gradient(180deg,
        rgb(250, 208, 145) 0%,
        rgb(233, 172, 92) 46.92%,
        rgb(236, 138, 58)100%);
    box-shadow:
      3px 3px 4px 1px rgba(233, 172, 92, 0.6),
      2px 10px 9px 2px rgba(233, 172, 92, 0.6),
      inset -6px 0px 5px rgb(233, 172, 92),
      inset 6px -3px 7px 2px rgb(233, 172, 92);
    height: 42px;
    border: none;
    /* 去除边框 */

    font-size: 20px;
    font-weight: 900;
    letter-spacing: 2px;
    line-height: 18px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
  }
</style>

  <style>
  /* 将 /deep/ 选择器替换为 ::v-deep 或 :deep() 选择器 */
  :deep(.el-timeline-item__timestamp) {
    font-size: 14px;
    font-weight: 600;
    color: rgb(23, 35, 63);
  }

  /* 创作按钮下拉菜单的网格布局样式 */
  :deep(.create-dropdown-menu) {
    padding: 0 !important;
  }

  .create-grid-layout {
    padding: 10px;
  }

  .create-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
    width: 400px;
  }

  .create-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #e8e8e8;
  }

  .create-item:hover {
    background-color: #f0f9ff;
    border-color: #409eff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
  }

  .create-icon {
    font-size: 24px;
    color: #409eff;
    margin-bottom: 8px;
  }

  .create-text {
    font-size: 12px;
    color: #606266;
    text-align: center;
    white-space: nowrap;
  }

  .create-item:hover .create-text {
    color: #409eff;
  }

  .create-center-item {
    grid-column: 1 / 5;
  }

  /* 用户悬停卡片样式 */
  .user-hover-card {
    width: 240px;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid #e8e8e8;
  }

  .user-card-header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .user-avatar-section {
    position: relative;
    margin-right: 12px;
  }

  .vip-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    background: linear-gradient(135deg, #ff6b6b, #feca57);
    color: white;
    font-size: 8px;
    padding: 1px 4px;
    border-radius: 6px;
    font-weight: bold;
  }

  .vip-badge-right {
    position: absolute;
    top: -3px;
    right: -3px;
    background: #ff6600;
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 10px;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(255, 102, 0, 0.4);
    border: 2px solid #fff;
    line-height: 1;
  }

  .avatar-container {
    position: relative;
    display: inline-block;
  }

  .user-avatar-section {
    position: relative;
    display: inline-block;
  }

  /* VIP样式统一规范 */
  .vip-badge-main {
    position: absolute !important;
    right: -2px !important;
    bottom: -2px !important;
    top: auto !important;
    left: auto !important;
    font-size: 8px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-weight: bold;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    text-transform: uppercase;
  }

  .vip-badge-right {
    position: absolute;
    right: -2px;
    bottom: -2px;
    font-size: 8px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-weight: bold;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    text-transform: uppercase;
  }

  /* VIP红底金字 */
  .vip-badge-main[data-vip="VIP"],
  .vip-badge-right[data-vip="VIP"] {
    background: #ff4757;
    color: #ffd700;
    border: 2px solid #ffd700;
  }

  /* SVIP蓝底金字 */
  .vip-badge-main[data-vip="SVIP"],
  .vip-badge-right[data-vip="SVIP"] {
    background: #121ec9;
    color: #ffd700;
    border: 2px solid #ffd700;
  }

  /* SSVIP黑底金字 */
  .vip-badge-main[data-vip="SSVIP"],
  .vip-badge-right[data-vip="SSVIP"] {
    background: #000000;
    color: #ffd700;
    border: 2px solid #ffd700;
  }

  /* MAX渐变底白字 */
  .vip-badge-main[data-vip="MAX"],
  .vip-badge-right[data-vip="MAX"] {
    background: linear-gradient(45deg, #ff4757, #ffd700);
    color: white;
    border: 2px solid white;
    box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
  }

  .user-info-section {
    flex: 1;
    min-width: 0;
  }

  .user-name-row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  .nickname {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    margin-right: 6px;
  }

  .nickname:hover {
    color: #409eff;
  }

  .gender-icon {
    font-size: 14px;
  }

  .gender-icon:first-of-type {
    color: #409eff;
  }

  .gender-icon:last-of-type {
    color: #f56c6c;
  }

  .user-level-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .level-img {
    height: 16px;
    margin-right: 6px;
  }

  .user-summary {
    font-size: 12px;
    color: #999;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 160px;
  }

  /* 用户悬停卡片样式 */
  .user-hover-card {
    position: relative;
    overflow: visible;
  }

  .user-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    position: relative;
    overflow: visible;
  }

  /* Element UI 下拉菜单项样式 */
  .userDropdownMenuItem {
    overflow: visible !important;
  }

  .el-dropdown-menu {
    overflow: visible !important;
  }

  .el-dropdown-menu .el-dropdown-menu__item {
    overflow: visible !important;
  }

  .user-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 12px;
  }

  .action-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 12px;
    color: #666;
  }

  .action-item:hover {
    background-color: #f5f7fa;
    color: #409eff;
  }

  .action-item i {
    margin-right: 6px;
    font-size: 14px;
  }

  .user-card-footer {
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
  }

  .logout-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 12px;
    color: #999;
  }

  .logout-btn:hover {
    background-color: #fef0f0;
    color: #f56c6c;
  }

  .logout-btn i {
    margin-right: 6px;
    font-size: 14px;
  }

  /* 搜索建议下拉框 */
  .search-suggestions {
    position: absolute;
    top: 50px;
    left: 0;
    width: 320px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: none;
    overflow: visible;
  }

  .suggestions-list {
    max-height: none;
    overflow: visible;
    padding: 0;
  }



  /* 建议项样式 */
  .suggestion-item {
    display: flex;
    align-items: center;
    padding: 6px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    height: 32px;
    box-sizing: border-box;
  }

  .suggestion-item:last-child {
    border-bottom: none;
  }

  .suggestion-item:hover {
    background-color: #f8f9fa;
  }

  .suggestion-icon {
    font-size: 13px;
    color: #999;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .suggestion-text {
    flex: 1;
    font-size: 13px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .suggestion-item:hover .suggestion-text {
    color: #1890ff;
  }

  /* 热门标签 */
  .suggestion-label {
    font-size: 9px;
    color: #fff;
    background: #ff4757;
    padding: 1px 3px;
    border-radius: 2px;
    margin-left: 6px;
    flex-shrink: 0;
    font-weight: normal;
    line-height: 1;
  }

  /* 页脚样式 - 参考ITMarket.vue设计 */
  .site-footer {
    background-color: #fff;
    color: #666;
    font-size: 12px;
    padding: 20px 0;
    border-top: 1px solid #e8e8e8;
    box-shadow: 0 -1px 3px rgba(0,0,0,0.05);
    width: 100%;
    margin-top: 40px;
    
    .footer-container {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      box-sizing: border-box;
    }
    
    .footer-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 40px;
    }
    
    .footer-left {
      display: flex;
      flex-wrap: nowrap;
      gap: 20px;
      
      .contact-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
        
        i {
          color: #999;
          margin-right: 6px;
          font-size: 14px;
        }
        
        span {
          color: #666;
        }
      }
    }
    
    .footer-center {
      .beian-info {
        display: flex;
        justify-content: center;
        
        .beian-item {
          color: #666;
          white-space: nowrap;
        }
      }
    }
    
    .footer-right {
      text-align: right;
      
      .social-links {
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;
        
        .social-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 8px;
          color: #666;
          transition: all 0.3s ease;
          text-decoration: none;
          
          &:hover {
            background-color: #00a1d6;
            color: white;
          }
          
          i {
            font-size: 14px;
          }
        }
      }
      
      .copyright {
        color: #999;
        white-space: nowrap;
        font-size: 12px;
      }
    }
    
    /* 响应式设计 */
    @media screen and (max-width: 768px) {
      padding: 16px 0;
      
      .footer-container {
        padding: 0 16px;
      }
      
      .footer-row {
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
      }
      
      .footer-left {
        flex-direction: column;
        gap: 8px;
        
        .contact-item {
          justify-content: center;
        }
      }
      
      .footer-center,
      .footer-right {
        text-align: center;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/home.vue